import { gql } from "@apollo/client";

export const GET_COUNTRY = gql`
  query Country($slug: String!) {
    country(slug: $slug) {
      id
      tagTitle
      tagDescription
      tagKeywords
      ogType
      ogSiteName
      ogTitle
      ogDescription
      ogImage
      ogImageWidth
      ogImageHeight
      ogImageAlt
      ogImageType
      seoText

      languages
      languageDefault

      regions {
        id
        # title
        cities {
          id
          slug
          title
          longitude
          latitude
          # region {
          #   id
          #   title
          # }
        }
      }
    }
  }
`;

export const GET_COUNTRIES = gql`
  query Countries {
    countries {
      id
      title
      slug
      latitude
      longitude
    }
  }
`;

export const GET_COUNTRIES_AND_CITIES = gql`
  query Countries {
    countries {
      id
      title
      slug
      # latitude
      # longitude

      regions {
        id
        cities {
          id
          slug
          title
          # longitude
          # latitude

          clubs {
            id
            title
            titleShort
            icon
            slug
            # longitude
            # latitude

            halls {
              id
              latitude
              longitude
              # description
              # descriptionHtml
              # name
              # address
              # title
              # phone
            }
          }
        }
      }
    }
  }
`;

export const GET_CITIES_BY_COUNTRY = gql`
  query Countries($slug: String!) {
    country(slug: $slug) {
      id
      title
      slug
      # latitude
      # longitude
      regions {
        id
        title
        cities {
          id
          slug
          title

          clubs {
            id
            slug
            title
            titleShort
            icon
            halls {
              id
              latitude
              longitude
              # description
              # descriptionHtml
              # name
              # address
              # title
              # phone
            }
          }
        }
      }
    }
  }
`;

export const GET_COUNTRIES_SLUG = gql`
  query Countries {
    countries {
      id
      slug
      languages
    }
  }
`;

export const GET_COUNTRIES_SLUG_WITH_CITIES_SLUG = gql`
  query Countries {
    countries {
      id
      slug
      languages
      regions {
        id
        cities {
          id
          slug
        }
      }
    }
  }
`;

export const GET_CITIES_SLUG = gql`
  query Countries($slug: String!) {
    country(slug: $slug) {
      id
      languages
      languageDefault

      regions {
        id
        title
        cities {
          id
          slug
          title
          # activity {
          #   id
          #   slug
          #   title
          # }
        }
      }
    }
  }
`;

export const GET_CITIES_WITH_CATEGORIES = gql`
  # query Countries($slug: String!) {
  #   country(slug: $slug) {

  query Countries {
    countries {
      # query Cities {
      id
      slug
      languages
      regions {
        id
        cities {
          id
          slug

          activityCategories {
            id
            slug
            # title
          }
        }
      }
    }
  }
`;

export const GET_CLUBS_AND_ACTIVITIES_BY_CITY = gql`
  query City($id: Int, $slug: String) {
    city(id: $id, slug: $slug) {
      id
      title
      latitude
      longitude
      tagTitle
      tagDescription
      tagKeywords
      ogType
      ogSiteName
      ogTitle
      ogDescription
      ogImage
      ogImageWidth
      ogImageHeight
      ogImageAlt
      ogImageType
      googleTag
      seoText
      activities {
        id
        slug
        title

        category {
          id
          slug
          title
        }
      }

      activityCategories {
        id
        slug
        title
      }
      clubs: clubsActivities {
        club {
          id
          slug
          icon
          title
          titleShort
          description
          descriptionHtml
          activities {
            id
            slug
            title
            image
          }
          halls {
            id
            latitude
            longitude
            description
            descriptionHtml
            name
            address
            title
            phone
          }
        }

        activity {
          id
          slug
          title
          category {
            id
            slug
            title
          }
          # image
        }
      }
    }
  }
`;
